/*
* PdfVerticalContentContainer.js
* Created on 22-11-2017
* @author Olivier for &ranj
* 
*/

import { isNull } from "../../../util/TypeUtil";
import AbstractPdfContent from "./AbstractPdfContent";
import PdfTextContent from "./PdfTextContent";

export default class PdfVerticalContentContainer extends AbstractPdfContent {
    constructor(style) {
        super(style);

        this._alignCenter = false;
        this._content = [];

        this.setPropertiesFromObject(style);
    }

    setPropertiesFromObject(obj) {
        super.setPropertiesFromObject(obj);

        for (let property in obj) {
            if (obj.hasOwnProperty(property)) {
                switch (property) {
                    case ("align"):
                        this.setContentAlignment(obj[property]);
                        break;
                }
            }
        }
    }

    setContentAlignment(alignment) {
        this._alignCenter = alignment === "center";
    }

    addContent(content) {
        this._content.push(content);
        content.parent = this;
    }

    addText(text, style) {
        if (isNull(style.width)) style.width = this._width;

        const pdfText = new PdfTextContent(text, style);
        this.addContent(pdfText);
    }

    calculateBounds(doc) {
        let height = 0;
        let width = 0;

        for (let i = 0; i < this._content.length; i++) {
            this._content[i].calculateBounds(doc);

            height += this._content[i].getFullHeight();
            width = Math.max(width, this._content[i].getFullWidth());
        }

        if (this._width === 0) {
            this.setWidth(width);
        }
        this.setHeight(height);
    }

    printToDocument(doc, x, y) {
        super.printToDocument(doc, x, y);

        let top = y + this._padding[0];
        let left = x + this._padding[3];

        //print content to document
        for (let i = 0; i < this._content.length; i++) {
            let curY = top;
            for (let j = 0; j < i; j++) {
                curY += this._content[j].getFullHeight();
            }

            let offsetX = 0;
            if (this._alignCenter) {
                let width = this._content[i].getWidth();
                offsetX = (this._width - width) / 2;
            }

            this._content[i].printToDocument(doc, left + offsetX, curY);
        }
    }
}